import { jsx as _jsx } from "react/jsx-runtime";
import WorkOrderDetails from './work-order-details';
import styled from 'styled-components';
import { useTravelTime } from 'modules/Workorder/api';
const WorkOrderDetailsWrapper = styled.div `
  width: 100%;
  max-width: 750px;
`;
export const WorkOrderDetailsContainer = ({ done, workOrder, totalTimeEstimate, inWorkLog, }) => {
    const { travelTime, isFetching, isError } = useTravelTime(workOrder.workOrderId);
    return (_jsx(WorkOrderDetailsWrapper, { children: !isError && (_jsx(WorkOrderDetails, { isFetching: isFetching, done: done, workOrder: workOrder, totalTimeEstimate: totalTimeEstimate, travelDuration: travelTime === null || travelTime === void 0 ? void 0 : travelTime.travelDuration, workDuration: travelTime === null || travelTime === void 0 ? void 0 : travelTime.workDuration, inWorkLog: inWorkLog })) }));
};
